var React = require('react');

function IconTicket (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.889 3.667H17.11V11H4.89V3.667Zm15.278 3.666c0 1.013.82 1.834 1.833 1.834v3.666c0 1.013-.82 1.834-1.833 1.834H1.833A1.833 1.833 0 0 1 0 12.833V9.167A1.833 1.833 0 1 0 0 5.5V1.833C0 .821.82 0 1.833 0h18.334C21.179 0 22 .82 22 1.833V5.5c-1.012 0-1.833.82-1.833 1.833Zm-1.834-3.972a.917.917 0 0 0-.916-.917H4.583a.917.917 0 0 0-.916.917v7.945c0 .506.41.916.916.916h12.834c.506 0 .916-.41.916-.916V3.36Z"}));
}

IconTicket.defaultProps = {"fill":"currentColor","viewBox":"0 0 22 15"};

module.exports = IconTicket;

IconTicket.default = IconTicket;
